import { COMPONENTS } from './constants';
import { Aplazame, Card, Openpay, PCI, Tpv } from '../components';
import { METHOD, PROVIDER } from '../Payment.constants';

const { APLAZAME, CARD, CARD_PREPAY, PCIPROXY, TPV } = METHOD;
const { HIPAY, MULTIPAGOS, OPENPAY, PAYBOX, REDSYS, REDUNIQ } = PROVIDER;

export const getComponent = ({ cardValidation, method, methodConfig, provider } = {}) => {
  let component;

  if (methodConfig) component = COMPONENTS[methodConfig.component];
  else if ([CARD, CARD_PREPAY, PCIPROXY].includes(method) && !cardValidation)
    component = method === PCIPROXY ? PCI : Card;
  else if (method === TPV && [HIPAY, MULTIPAGOS, PAYBOX, REDSYS, REDUNIQ].includes(provider)) component = Tpv;
  else if (method === TPV && provider === OPENPAY) component = Openpay;
  else if (method === APLAZAME) component = Aplazame;

  return component;
};
